import { withMixpanel } from "./mixpanelClient";
import { isMixpanelDevMode } from "./mixpanelDevMode";

/**
 * Shared client-side Mixpanel tracking entry point. Stamps every frontend event
 * with `triggered_from: "frontend"` so it pairs with the backend's
 * `triggered_from: "backend"` (see peareasy-services MixpanelTrackingService),
 * letting reports tell client- and server-fired events apart.
 *
 * Section helpers (sbcMixpanel.ts, squadBuilderMixpanel.ts, ...) route through
 * this instead of calling mixpanel.track directly, so cross-cutting props live
 * in one place. Explicit props win over the defaults on key collisions.
 */
export const mixpanelTrack = (
  event: string,
  props: Record<string, unknown> = {},
) => {
  const enriched = { triggered_from: "frontend", ...props };
  // Dev-mode visibility (local dev + staging): see exactly which event fired
  // (and with what props) on each interaction, without round-tripping through
  // the Mixpanel UI. In dev mode the SDK is opted out (see index.tsx), so this
  // is the only signal — and it never hits the production project. Backend-fired
  // events (e.g. favourite, update_recommendations) won't show here; watch the
  // NestJS console instead.
  if (isMixpanelDevMode()) {
    // eslint-disable-next-line no-console
    console.debug(
      `%c[mixpanel]%c ${event}`,
      "color:#7856ff;font-weight:bold",
      "color:inherit",
      enriched,
    );
  }
  withMixpanel((mp) => mp.track(event, enriched));
};
